<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-file-invoice-dollar"></i><span> Pagos</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('pagos.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getListPagos(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getListPagos(1,pag_mostrar)" placeholder="Nombre o Apellido" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getListPagos(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Empleado</b></th>
                                            <th><b>T.General</b></th>
                                            <th><b>S.Básico</b></th>
                                            <th><b>Bono</b></th>
                                            <th><b>Comisión(%)</b></th>
                                            <th><b>Comisión($)</b></th>
                                            <th><b>Fecha de Pago</b></th>
                                            <th><b>Descripción</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listPagos.length">
                                        <tr v-for="(c, index) in listPagos" :key="index">

                                            <td v-text="c.asesor"></td>
                                            <td v-text="'$'+formatPrice(c.total)"></td>
                                            <td v-text="c.sueldo_basico"></td>
                                            <td v-text="c.bono"></td>
                                            <td v-text="c.por_comision"></td>
                                            <td v-text="c.comision"></td>
                                            <td v-text="c.fecha_pago"></td>
                                            <td v-text="c.descripcion"></td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="7" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Evidencia-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Evidencia</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Empleado Asignado</label>
                                        <v-select
                                            v-model="vaCrePagos.empleado"

                                            @search="selectEmpleadoPago"
                                            v-on:change="traerComision()"
                                            label="empleado"
                                            :options="arrayEmpleadoPago"
                                            placeholder="Buscar Empleado..."
                                            @input="getDatosEmpleadoPago"
                                            >
                                        <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="estado">Mes</label>
                                        <select class="custom-select" v-model="mes" v-on:change="traerComision()">
                                            <option value="0">Todos</option>
                                            <option v-for="mes in mesesList" :key="mes.id" :value="mes.id" v-text="mes.nombre">2020</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="clasificacion" class="mr-2">Clasificación</label>
                                        <select class="custom-select" v-model="vaCrePagos.clasificacion" id="clasificacion" disabled>
                                            <option value="1">Merbrok</option>
                                            <option value="2">Asociados</option>
                                        </select>
                                    </div>
                                </div>


                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Bono</label>
                                        <money v-model="vaCrePagos.bono"  v-bind="money" class="form-control"></money>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Descripción</label>
                                        <input type="text" class="form-control" id="url" v-model="vaCrePagos.cDescripcion" placeholder="Agregue una descripción">
                                    </div>
                                </div>

                                <div class="col-md-12">

                                    <div class="scrollTable">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>F. Cotización</th>
                                                    <th>F. Venta</th>
                                                    <th>Monto</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="arraycomision.length">
                                                <tr v-for="c in arraycomision" :key="c.id">
                                                    <td v-text="c.fecha_cotizacion"> </td>
                                                    <td v-text="c.fecha_venta"> </td>
                                                    <td v-text="'$'+c.prima_neta"></td>
                                                </tr>

                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Total Primas Netas:</strong>
                                                    </td>
                                                    <td>$ {{formatPrice(total)}} </td>
                                                </tr>
                                                
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Sueldo Base:</strong>
                                                    </td>
                                                    <td>$ {{formatPrice(suelo_basico)}} </td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Primas Netas Nuevos:</strong>
                                                    </td>
                                                    <td>$ {{formatPrice(prima_neta_nuevos)}} </td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Comisión nuevos(%):</strong>
                                                    </td>
                                                    <td v-text="vaCrePagos.por_comision + '%'">
                                                    </td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Primas Netas Renovación:</strong>
                                                    </td>
                                                    <td>$ {{formatPrice(prima_neta_renovacion)}} </td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Comisión Renovación(%):</strong>
                                                    </td>
                                                    <td v-text="vaCrePagos.por_renovacion + '%'">
                                                    </td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Total Comisión:</strong>
                                                    </td>
                                                    <td v-text="'$ '+formatPrice(vaCrePagos.total_comision)"></td>
                                                </tr>
                                                <tr style="background-color: #CEECF5;">
                                                    <td colspan="2" align="right">
                                                        <strong>Bono:</strong>
                                                    </td>
                                                    <td v-text="'$ '+formatPrice(vaCrePagos.bono)"></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="3">
                                                        No tiene comisión
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>

                                <div class="col-md-12">

                                <div class="input-group">
                                    <span class="input-group">Total a Pagar:</span>
                                    <p class="form-control" v-text="'$' + formatPrice(totalPagar())"></p>
                                </div>
                                </div>
                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary" @click="setRegistrarPago" v-text="nameButon">Guardar</button>
                           
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Evidencia-------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
const CLASIFICACION_USER = Object.freeze({ MERBROK: 1, ASOCIADOS: 2 });
export default {
    props: ['ruta'],
    data() {
        return {
            cBusqueda: '',
            listPagos: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCrePagos:{
                eId: 0,
                cNombre: '',
                cDescripcion: '',
                idempleado: 0,
                empleado: '',
                bono : 0,
                total_comision: 0,
                por_comision: 0,
                clasificacion : 0,
                por_renovacion : 0

            },
            total: 0.0,
            prima_neta_nuevos: 0.0,
            prima_neta_renovacion: 0.0,
            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },
            arrayEmpleadoPago:[],
            arraycomision: [],
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            mesesList : [
                {id: 1 ,  nombre: "Enero"},
                {id: 2 ,  nombre: "Febrero"},
                {id: 3 ,  nombre: "Marzo"},
                {id: 4 ,  nombre: "Abril"},
                {id: 5 ,  nombre: "Mayo"},
                {id: 6 ,  nombre: "Junio"},
                {id: 7 ,  nombre: "Julio"},
                {id: 8 ,  nombre: "Agosto"},
                {id: 9 ,  nombre: "Septiembre"},
                {id: 10 , nombre: "Octubre"},
                {id: 11 , nombre: "Noviembre"},
                {id: 12 , nombre: "Diciembre"},
            ],
            mes: moment().format('M'),
            suelo_basico: 0.00,
        }
    },
    mixins: [alertasM],
    computed: {

        isActived: function() {
                return this.pagination.current_page;
        },
            //Calcula los elementos de la paginación
        pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
        },
    },

    methods: {


        getListPagos(page,pag_mostrar){

          var url = '/pagos';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta       = res.data;
                this.listPagos      = respuesta.pago;
                this.pagination     = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              console.error(err);
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
          })

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getListPagos(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloModal = "Registrar Pago Empleado";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.vaCrePagos.cNombre = "";
            this.vaCrePagos.cDescripcion  = "";
            this.vaCrePagos.eId = 0;
            this.vaCrePagos.idempleado = 0;
            this.vaCrePagos.empleado = "";
            this.vaCrePagos.bono = 0.0;
            this.vaCrePagos.total_comision = 0.0;
            this.vaCrePagos.por_comusion = 0.0;
            this.total = 0.00;
            this.arraycomision = [];
        },

        selectEmpleadoPago(search,loading,defecto){
                let me=this;
                var url=  '/pagos/getListarUsuariosPagos';

                if(defecto==null){
                    loading(true)
                    axios.post(url,{ params:{ 'filtro': search } } )
                        .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arrayEmpleadoPago=respuesta;
                        loading(false)
                    })
                    .catch(function (error) {
                        if (err.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                        }
                        console.log(error);
                    });
                }else{

                    axios.get(url,{ params:{ 'filtro': search} } )
                        .then(function (response) {
                        let respuesta = response.data;
                        me.arrayEmpleadoPago=respuesta;

                    })
                    .catch(function (error) {
                        if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                        }
                        console.log(error);
                    });

                }
        },

        getDatosEmpleadoPago(val1){
            let me = this;
            
            if(val1 ==null){

                me.vaCrePagos.idempleado    = 0;
                me.vaCrePagos.empleado      = '';
                me.vaCrePagos.clasificacion = 0;
                me.arraycomision            = [];

             }else{

                me.loading = true;
                me.vaCrePagos.idempleado    = val1.id;
                me.vaCrePagos.empleado      = val1.empleado;
                me.vaCrePagos.por_comision  = val1.comision;
                me.vaCrePagos.clasificacion = val1.clasificacion;
                me.traerComision()
             }
        },

        traerComision(){

          var url = '/pagos/obtenercomision';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.post(url,
            {
                'id'  : this.vaCrePagos.idempleado,
                'mes' : this.mes,
                'clasificacion' : this.vaCrePagos.clasificacion,
                'comision'      : this.vaCrePagos.por_comision,
            })

          .then(res => {
                var respuesta                   = res.data;
                this.arraycomision              = respuesta.comision
                this.total                      = respuesta.total_prima_neta
                this.vaCrePagos.por_renovacion   = respuesta.por_renovacion
                this.prima_neta_nuevos          = respuesta.prima_neta_nuevos
                this.prima_neta_renovacion      = respuesta.prima_neta_renovacion
                this.suelo_basico               = respuesta.suelo_basico
                this.vaCrePagos.total_comision = respuesta.total_comision
                this.vaCrePagos.por_comision    = respuesta.por_comision;
                /*vaCrePagos.total_comision
                 */
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
               this.openCargando(true);//Desactivamos ventana de carga de bloqueo
              console.error(err);
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       }
                    }
          })
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        totalPagar(){
            var total = 0.0;
            total = Number(this.suelo_basico) + Number(this.vaCrePagos.total_comision) + this.vaCrePagos.bono;
            return total;
        },

        setRegistrarPago(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/pagos/registrar';


            axios.post(url, {
                'id'            : this.vaCrePagos.idempleado,
                'monto'         : this.vaCrePagos.bono,
                'descripcion'   : this.vaCrePagos.cDescripcion,
                'mes'           : this.mes,
                'clasificacion' : this.vaCrePagos.clasificacion,
                'comision'      : this.vaCrePagos.por_comision,
            }).then(res => {

                

                if(res.data.status){

                    this.getListPagos(1,this.pag_mostrar);
                    this.notify(" Pago registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    this.cleanVariables();//Limpiamos el form
                    this.modalShow=false;
                }else{

                this.openCargando(true);
                   this.notify(" Ha ocurrido un error al registrar el Pago","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
                console.error(err);
            })
        },




    },
    mounted() {

            this.getListPagos(1,this.pag_mostrar);


        },
}
</script>

<style>
</style>
